import { render, staticRenderFns } from "./RoutePlace.vue?vue&type=template&id=5aa1b015&"
import script from "./RoutePlace.vue?vue&type=script&lang=js&"
export * from "./RoutePlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports